import { render } from "./DetailsView.vue?vue&type=template&id=35978d12"
import script from "./DetailsView.vue?vue&type=script&lang=js"
export * from "./DetailsView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Hardcore\\Documents\\LEARNING\\VUE PROJECT\\movie-review\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__